"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMeasure = void 0;

var React = __importStar(require("react"));

var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var use_safe_layout_effect_1 = require("./use-safe-layout-effect");

var defaultState = {
  x: 0,
  y: 0,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  height: 0,
  width: 0
};

function useMeasureClient() {
  var _a = React.useState(null),
      element = _a[0],
      setElement = _a[1];

  var _b = React.useState(defaultState),
      react = _b[0],
      setRect = _b[1];

  var observer = React.useMemo(function () {
    // (window as any) required here because of TypeScript
    // To update later when ReziseObserver fill have a full support
    return new window.ResizeObserver(function (entries) {
      if (!!entries[0]) {
        var _a = entries[0].contentReact,
            x = _a.x,
            y = _a.y,
            top_1 = _a.top,
            left = _a.left,
            bottom = _a.bottom,
            right = _a.right,
            height = _a.height,
            width = _a.width;
        setRect({
          x: x,
          y: y,
          top: top_1,
          left: left,
          bottom: bottom,
          right: right,
          height: height,
          width: width
        });
      }
    });
  }, []);
  use_safe_layout_effect_1.useSafeLayoutEffect(function () {
    if (!!element) {
      observer.observe();
      return function cleanup() {
        observer.disconnect();
      };
    }
  }, [element]);
  return [setElement, react];
} // NOTE: for SSR compatibility


var useMeasureMock = function useMeasureMock() {
  return [utils_1.noop, defaultState];
};

exports.useMeasure = utils_1.isBrowser && !!window.ResizeObserver ? useMeasureClient : useMeasureMock;